import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import Brand from "@/components/common/Brand";
import NotificationsBell from "@/components/socio/NotificationsBell";
import { logoutSocio } from "@/data/socioAuthStore";
import { APP_TOPBAR } from "@/constants/testIds";

/**
 * Members app top bar with glassmorphism.
 * Kept minimal per premium members club aesthetic. Includes the
 * "Cerrar sesión" affordance for the authenticated socio.
 */
export default function AppTopBar() {
  const navigate = useNavigate();
  const handleLogout = () => {
    // Sprint 48 · Smart Queue vive 100 % en backend. El logout revoca
    // la sesión (Sprint 47) y la entrada de fila del socio queda sin
    // heartbeat: expira por inactividad y se libera al siguiente en la
    // cola. No es necesario liberar manualmente aquí.
    logoutSocio();
    navigate("/", { replace: true });
  };

  return (
    <header className="sticky top-0 z-40 w-full glass border-b hairline">
      <div className="w-full max-w-2xl mx-auto px-6 md:px-8 py-4 flex items-center justify-between gap-3">
        <Brand />
        <div className="flex items-center gap-2">
          <NotificationsBell />
          <button
            type="button"
            data-testid={APP_TOPBAR.btnLogout}
            onClick={handleLogout}
            aria-label="Cerrar sesión"
            className="inline-flex items-center gap-2 rounded-full px-3.5 py-2 text-xs font-medium border hairline bg-card/70 text-foreground hover:bg-muted transition-colors"
          >
            <LogOut className="w-3.5 h-3.5" strokeWidth={1.7} />
            <span className="hidden sm:inline">Cerrar sesión</span>
          </button>
        </div>
      </div>
    </header>
  );
}
